import { useLocation, Navigate } from "react-router-dom";
import queryString from "query-string";
import Login from "../Component/Authentication/Login";
import Default from "../Component/Dashboard/Default/Default";
import FormWizardOneContainer from "../Component/Forms/FormsLayout/FormWizardOne/FormWizardOne";
import ReportWizardContainer from "../Component/Dashboard/Default/HDMReports/ReportWizard/ReportWizardContainer";
import FormWizardContainer from "../Component/Dashboard/HDMForms/FormWizard/FormWizardContainer";
import LegalDocRequestForm from "../Component/Dashboard/HDMForms/LegalDocRequestForm";
import { query } from "express";

const CustomRouter = () => {
  const location = useLocation();
  const login = localStorage.getItem("login"); // Check authentication status
  const { pathname, search } = location; // Capture the intended path

  const queryParams = queryString.parse(search);
  const filterStatus = queryParams.filterStatus as string | undefined; // Safely handle query parameter
  const reportTitle = queryParams.reportTitle as string | undefined; // Safely handle query parameter
  // Define route mapping logic
  if (!login) {
    localStorage.setItem("redirectAfterLogin", pathname + search);
    console.log("Redirecting to login page");
    console.log(pathname, search);
    return <Login />;
  } else {
    console.log("Authenticated route. Passing in filterStatus", filterStatus);
  }

  // Authenticated route logic
  switch (pathname) {
    case "/dashboard/default":
      return <Default />;
    case "/pipeline-report":
      return <ReportWizardContainer reportType='pipeline' />;
    case "/pipeline-compare-report":
      return <ReportWizardContainer reportType='pipeline-compare' />;
    case "/utilization-report":
      return <ReportWizardContainer reportType='utilization' />;
    case "/booked-contracted-report":
      return <ReportWizardContainer reportType='bookedContracted' />;
    case "/rev-bookings-report":
      return <ReportWizardContainer reportType='bookedContracted' />;
    case "/leaderboard":
      return <ReportWizardContainer reportType='leaderboard' />;
    case "/jobs-report":
      return (
        <ReportWizardContainer
          reportType='openJobs'
          filterStatus={filterStatus}
          reportTitle={reportTitle}
        />
      );
    case "/client-performance-report":
      return <ReportWizardContainer reportType='clientPerformance' />;
    case "/recruiter-performance-report":
      return <ReportWizardContainer reportType='recruiterPerformance' />;
    case "/screening":
      return <FormWizardOneContainer />;
    case "/screening/form":
      return <FormWizardOneContainer />;
    case "/asset-request-form":
      return <FormWizardContainer formType='assetRequestForm' />;
    case "/legal-doc-requests-report":
      return <ReportWizardContainer reportType='legalDocRequests' />;
    case "/legal-doc-request-form":
      return <FormWizardContainer formType='legalDocRequestForm' />;
    case "/asset-request-status-report":
      return <ReportWizardContainer reportType='assetRequestStatus' />;
    case "/help-desk-request-form":
      return <FormWizardContainer formType='helpDeskRequestForm' />;
    default:
      // Redirect to default dashboard if route is not matched
      return <Navigate to='/dashboard/default' replace />;
  }
};

export default CustomRouter;
